import Api from "@/api/api"
import { timeago } from "@/utils/base"

export const communityArticle = {
  namespaced: true,
  state: () => ({
    detail: null,
    commentList: null
  }),
  getters: {
    detail: state => state.detail,
    commentList: state => state.commentList
  },
  mutations: {
    SET_DETAIL: (state, { detail }) => {
      state.detail = detail
    },
    SET_COMMENT_LIST: (state, { commentList }) => {
      state.commentList = commentList
    }
  },
  actions: {
    FETCH_DETAIL: ({ commit }, { bbs_id, article_id }) => {
      return Api.communityArticle.detail(bbs_id, article_id).then(res => {
        const detail = res.data
        detail.content = detail.content.replace(
          /https:\/\/resource.ghzs.com\/image\/community\/5b694f242924bcf82441b3fc\.png/g,
          "http://static-web.ghzs.com/website-static/images/icon_article.png"
        )
        detail.content = detail.content.replace(
          /https:\/\/resource.ghzs.com\/image\/community\/575fa87d8ab49e12658b4cds\.png/g,
          "http://static-web.ghzs.com/website-static/images/icon_reply.png"
        )
        detail.content = detail.content.replace(
          /ghzhushou:\/\/[^("|')]*/g,
          match => {
            return `javascript:void(0); redirect('${match}')`
          }
        )
        commit("SET_DETAIL", { detail })
      })
    },
    FETCH_COMMENT_LIST: ({ commit }, { bbs_id, article_id, params }) => {
      return Api.communityArticle
        .comments(bbs_id, article_id, params)
        .then(res => {
          commit("SET_COMMENT_LIST", {
            commentList: res.data.map(v => {
              if (v.list_reply && v.list_reply.length > 3) {
                v.isExpand = false
              }
              v.timeago = timeago(v.time * 1000)
              return v
            })
          })
        })
    }
  }
}
